import axios from 'axios'
import { apiDelete, apiGet, apiPost, handleApiError } from '@api/api.utils'
import api from '@services/api.service'
import type { AvatarCatalogResponse, AvatarDeleteResponse, AvatarFolderResponse, AvatarUploadResponse } from './types'

const route = '/operatorAvatars'
export const getAvatarCatalog = () => apiGet<AvatarCatalogResponse>(`${route}/catalog`)
export const createAvatarFolder = (name: string) => apiPost<AvatarFolderResponse>(`${route}/folders`, undefined, {name})
const retryAfterMs = (headers: unknown): number => {
    const values = headers && typeof headers === 'object' ? headers as Record<string, unknown> : {}
    const entry = Object.entries(values).find(([key]) => key.toLowerCase() === 'retry-after')?.[1]
    const value = String(Array.isArray(entry) ? entry[0] ?? '' : entry ?? '').trim()
    const seconds = /^\d+(?:\.\d+)?$/.test(value) ? Number(value) : NaN
    const date = /[a-z]/i.test(value) ? Date.parse(value) : NaN
    const delay = Number.isFinite(seconds) ? seconds * 1000 : date - Date.now()
    return Number.isFinite(delay) ? Math.max(1000, Math.ceil(delay)) : 60000
}

export const uploadCatalogAvatar = async (file: File, folderID: number, onProgress?: (percent: number) => void, signal?: AbortSignal): Promise<AvatarUploadResponse> => {
    const data = new FormData()
    data.append('avatar', file)
    data.append('folderID', String(folderID))
    try {
        const response = await api.post<AvatarUploadResponse>(`${route}/upload`, data, {
            signal,
            onUploadProgress: event => {
                if (event.total && event.total > 0) onProgress?.(Math.max(0, Math.min(100, Math.round(event.loaded / event.total * 100))))
            },
        })
        return response.status === 429 ? {...response.data, retryAfterMs: retryAfterMs(response.headers)} : response.data
    } catch (error) {
        const response = handleApiError(error) as AvatarUploadResponse
        return response.status === 429 && axios.isAxiosError(error)
            ? {...response, retryAfterMs: retryAfterMs(error.response?.headers)} : response
    }
}
export const deleteCatalogAvatar = (avatarID: number, replacementAvatarID?: number) =>
    apiDelete<AvatarDeleteResponse>(`${route}/${avatarID}`, undefined, replacementAvatarID ? {replacementAvatarID} : {})
